<template>
  <div v-if="isMobile" class="flex flex-col gap-4">
    <div v-for="row in report" :key="row.code" class="bg-n-800 rounded-lg p-4 flex flex-col gap-3">
      <div class="flex justify-between items-center">
        <span class="text-n-300 text-xs">{{ t('couriers.identifier') }}</span>
        <span class="font-medium">{{ row.code }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-n-300 text-xs">{{ t('couriers.address') }}</span>
        <span>{{ row.address }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-n-300 text-xs">{{ t('couriers.pickup-delivery') }}</span>
        <div class="flex flex-col">
          <div>{{ format(row.creationTime, 'dd/MM/yyyy - HH:mm') }}</div>
          <div v-if="row.closeTime">{{ format(row.closeTime, 'dd/MM/yyyy - HH:mm') }}</div>
        </div>
      </div>
      <div class="flex justify-between items-center">
        <div class="flex flex-col">
          <span class="text-n-300 text-xs">{{ t('couriers.payment-method') }}</span>
          <span>{{ getPaymentMethodLabel(row.paymentMethod) }}</span>
        </div>
        <div class="flex flex-col items-end">
          <span class="text-n-300 text-xs">{{ t('couriers.total') }}</span>
          <span class="font-medium">{{ currency(row.total) }}</span>
        </div>
      </div>
    </div>
  </div>
  <table v-else>
    <thead class="bg-n-800 h-12">
      <tr>
        <th class="px-2 align-middle text-left font-normal rounded-l">
          {{ t('couriers.identifier') }}
        </th>
        <th class="w-1/3 px-2 align-middle text-left font-normal">
          {{ t('couriers.address') }}
        </th>
        <th class="px-2 align-middle text-left font-normal">
          {{ t('couriers.pickup-delivery') }}
        </th>

        <th class="px-2 align-middle text-left font-normal">
          {{ t('couriers.payment-method') }}
        </th>
        <th class="px-2 align-middle text-left font-normal rounded-r">
          {{ t('couriers.total') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in report" :key="row.code">
        <td class="p-2">
          {{ row.code }}
        </td>
        <td class="p-2">
          {{ row.address }}
        </td>
        <td class="p-2">
          <div class="flex flex-col">
            <div>
              {{ format(row.creationTime, 'dd/MM/yyyy - HH:mm') }}
            </div>
            <div v-if="row.closeTime">
              {{ format(row.closeTime, 'dd/MM/yyyy - HH:mm') }}
            </div>
          </div>
        </td>
        <td class="p-2">
          {{ getPaymentMethodLabel(row.paymentMethod) }}
        </td>
        <td class="p-2">
          {{ currency(row.total) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup lang="ts">
import { format } from 'date-fns'
import { useI18n } from 'vue-i18n'

import { useMoney } from '@/composables/useMoney'
import type { CourierTab } from '@/types'
import { isMobile } from '@/utils/device-type'

withDefaults(
  defineProps<{
    report?: CourierTab[]
  }>(),
  {
    report: () => []
  }
)

const { t } = useI18n()
const { currency } = useMoney()

function getPaymentMethodLabel(method: string | null) {
  switch (method) {
    case 'cash':
      return t('couriers.cash')
    case 'card':
      return t('couriers.card')
    default:
      return method
  }
}
</script>
